import React from 'react';
import Modal from '../ui/Modal';
import { AlertTriangle, CheckCircle, X } from 'lucide-react';

interface RebillConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  item: {
    description: string;
    invoiceIds?: number[];
  };
}

const RebillConfirmDialog: React.FC<RebillConfirmDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  item
}) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Re-bill Item?" maxWidth="md">
      <div className="space-y-4">
        {/* Warning Icon */}
        <div className="flex items-center justify-center">
          <div className="w-16 h-16 bg-orange-100 dark:bg-orange-900/30 rounded-full flex items-center justify-center">
            <AlertTriangle className="w-8 h-8 text-orange-600 dark:text-orange-400" />
          </div>
        </div>

        {/* Warning Message */}
        <div className="text-center space-y-3">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
            This item has already been billed
          </h3>
          
          <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4">
            <p className="text-sm text-gray-700 dark:text-gray-300 mb-2">
              <strong>Item:</strong> {item.description}
            </p>
            
            {item.invoiceIds && item.invoiceIds.length > 0 && (
              <div className="flex items-center justify-center space-x-2">
                <CheckCircle className="w-4 h-4 text-green-600 dark:text-green-400" />
                <span className="text-sm text-gray-600 dark:text-gray-400">
                  Already billed on Invoice {item.invoiceIds.map(id => `#${id}`).join(', ')}
                </span>
              </div>
            )}
          </div>

          <p className="text-sm text-gray-600 dark:text-gray-400">
            Are you sure you want to bill this item again? This will create a duplicate charge.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end space-x-3 pt-4 border-t border-gray-200 dark:border-gray-700">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            className="px-4 py-2 text-sm font-medium text-white bg-orange-600 border border-transparent rounded-md hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
          >
            Yes, Bill Again
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default RebillConfirmDialog;
